<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-28" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header Card -->
      <div class="bg-gradient-to-r from-green-600 to-green-700 rounded-xl p-6 text-white">
        <div class="flex items-center gap-3">
          <div class="w-14 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="w-full">
            <h2 class="text-xl font-bold">نهایی کردن سفارش خرید</h2>
            <p class="text-sm text-green-50">آپلود فایل‌های خریداری شده</p>
          </div>
        </div>
      </div>

      <!-- Products List -->
      <div class="bg-white rounded-xl border border-gray-200 p-6 space-y-3">
        <h3 class="text-lg font-bold text-gray-900 mb-4">کالاهای انتخاب شده</h3>
        <div 
          v-for="item in request_items"
          :key="item.Id"
          class="p-4 bg-gray-50 border border-gray-200 rounded-lg hover:border-green-300 transition-all duration-200"
        >
          <div class="flex items-center gap-3 mb-3">
            <div class="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <div class="w-full">
              <h3 class="text-base font-bold text-gray-900">{{ item.ProductName }}</h3>
            </div>
          </div>
          
          <div class="grid grid-cols-2 gap-4">
            <div class="text-center p-3 bg-white rounded-lg">
              <p class="text-xs text-gray-600 mb-1">تعداد</p>
              <p class="text-sm font-bold text-gray-900">{{ item.Qty }} عدد</p>
            </div>
            <div class="text-center p-3 bg-white rounded-lg">
              <p class="text-xs text-gray-600 mb-1">شعبه</p>
              <p class="text-sm font-bold text-gray-900">{{ item.SourceBranchName }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Add File Section -->
      <div class="bg-white rounded-xl border border-gray-200 p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-bold text-gray-900">{{ $t('add_file') }}</h3>
          <button 
            v-if="files.length==0"
            @click="select_file()"
            class="w-10 h-10 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-lg flex items-center justify-center transition-all duration-200"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
          </button>
        </div>
        
        <input id="fileUpload" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.gif" type="file" hidden v-on:change="input_file_changed">
        
        <!-- File Grid -->
        <div v-if="files.length > 0" class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3 mt-4">
          <div 
            v-for="(item, i) in files"
            :key="i"
            class="relative group"
          >
            <img 
              :src="item.file" 
              class="w-full h-24 object-cover rounded-lg"
              loading="lazy"
            />
            <button 
              @click="delete_file(i)"
              class="absolute -top-2 -left-2 w-7 h-7 bg-red-600 hover:bg-red-700 text-white rounded-full flex items-center justify-center transition-all duration-200"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <p class="text-xs text-gray-600 mt-1 truncate">{{ item.title }}</p>
          </div>
        </div>
        
        <!-- Empty state for files -->
        <div v-else class="flex flex-col items-center justify-center py-12">
          <div class="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-3">
            <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <p class="text-gray-500 text-sm">فایلی انتخاب نشده است</p>
        </div>
      </div>

      <!-- Send Button -->
      <button 
        @click="save()"
        class="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2"
      >
        {{ $t('sendFiles') }}
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
      </button>

      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">{{ $t('no_records') }}</div>
      </infinite-loading>

    </div>
  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import { longClickDirective } from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        files: [],
        product_info_dialog:false,
        selected_product_info:{},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click:false,
        category_items: [],
        request_statuses: [],

        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {
      this.get_pre_requests()
      this.get_device_status();
    },

    methods: {
      get_device_status () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_pre_requests($state) {
        // this.request_items = [];
        this.request_items = JSON.parse(localStorage.getItem('buy_orders_finalize'))
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      save() {
        if (this.files.length) {
          this.upload_image(0)
          //
          // for (var i = 0; i < this.files.length; i++) {
          // }
        } else {
          bus.$emit('show_toast', [1500, this.$t('please_select_image')])
        }
      },
      select_file() {
        // if (index == 0) {
        // this.open_camera();
        // this.dialog_camera = true;
        // document.getElementById('fileUpload').click()
        // }
        // if (index == 1) {
        document.getElementById('fileUpload').click()
        // }
      },
      delete_file(index) {
        this.files.splice(index, 1)
      },
      input_file_changed() {
        console.log("input_file_changed")
        var self = this

        var reader = new FileReader()
        var f = document.getElementById('fileUpload').files
        // if (f != null) {
        reader.onloadend = function () {
          // console.log(reader.result);
          if (!reader.result.startsWith('data:image/webp')) {
            self.resizeBase64Img(reader.result, 700, 700).then(function (newImg) {
              // $("body").append(newImg[0]);
              // console.log("resized",newImg[0].src)
              var obj = {file: newImg[0].src, preview: reader.result, upload: 0}
              self.files.push(obj)
              reader = null;
              f = null;
              document.getElementById('fileUpload').files = null;
              obj = null;
            })
            // console.log(obj)
          } else {
            bus.$emit('show_toast', [1500, self.$t('fileIsNotGranted')])
          }
        };
        reader.readAsDataURL(f[0])

        // }

      },

      async resizeBase64Img(base64, minimum) {
        try {

          var canvas = document.createElement('canvas')

          var deferred = $.Deferred()
          $('<img/>').attr('src', base64).load(function () {
            var last_width = this.width
            var last_height = this.height

            if (last_width > last_height) {
              last_width = (last_width * minimum) / last_height
              last_height = minimum
            } else {
              last_height = (last_height * minimum) / last_width
              last_width = minimum
            }
            canvas.width = last_width
            canvas.height = last_height
            var context = canvas.getContext('2d')

            console.log(this.width, this.height)
            context.scale(last_width / this.width, last_height / this.height)
            context.drawImage(this, 0, 0)

            deferred.resolve($('<img/>').attr('src', canvas.toDataURL()))
          })
          return deferred.promise()
        } catch (e) {
          bus.$emit('show_toast', [3000, "error on Base64Img"])

        }
      },
      upload_image(index) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('ProcessId', this.$route.params.rec_id)
        form_data.append('Format', 'png')
        form_data.append('ReqType', 10)
        form_data.append('DocType', 1)
        var my_file = this.files[index].file

        var file = this.dataURLtoFile(my_file, 'attach.png')
        form_data.append('Picture', file)

        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            // self.send_signature(response.data.ArchiveId,response.data.ImageName);
            if (response.data.error == 0) {
              self.files[index].upload = 1
              self.files[index].ArchiveId = response.data.ArchiveId
              self.files[index].ImageName = response.data.ImageName
              // if (index < self.files.length - 1) {
              //   self.upload_image(index + 1)
              // } else {
                self.send_attach()
              // }

              // var finish_all = true;
              //   self.files.forEach(function (number) {
              //     if (number.upload != 1) {
              //       finish_all = false;
              //     }
              //   });
              // if (finish_all) {
              //   self.files[0].upload = 1;
              //
              // }
            } else {
              self.files[index].upload = 2
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      dataURLtoFile(dataurl, filename) {
        try {

          var arr = dataurl.split(',')
          var mime = arr[0].match(/:(.*?);/)[1]
          var bstr = atob(arr[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }

          return new File([u8arr], filename, {type: mime})
        } catch (e) {
          bus.$emit('show_toast', [3000, "error on dataURLtoFile"])

        }
      },

      send_attach() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        // console.log();

        var attachment_array = []

        self.request_items.forEach(function (number) {

          var pre_obj = {
            StatusId: self.request_statuses[12],
            ImageName: self.files[0].ImageName,
            Summary: '',
            FileTypeId: 1,
            GRequestProductId: number.GoodsRequestProductId,
          }
          attachment_array.push(pre_obj)
        })

        const send_data = {
          Attachments: attachment_array,
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddGoodsRequestProductFile', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])

            if (response.data.error == 0) {
              self.$router.go(-1)
            }

          }).catch(e => {
          this.errors.push(e)
        })
      }

    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
